(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsc-bundle-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsc-bundle-hero')) {
  customElements.define('bsc-bundle-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = this.querySelector('form');
      this.buy = this.querySelector('[data-buy]');
      this.status = this.querySelector('[data-status]');
      this.sticky = this.querySelector('[data-sticky]');
      this.busy = false;
      const gallery = this.querySelector('[data-gallery]');
      const track = this.querySelector('[data-gallery-track]');
      if (gallery && track) {
        const slides = [...track.querySelectorAll('[data-slide]')];
        const thumbs = [...gallery.querySelectorAll('[data-image-index]')];
        const previous = gallery.querySelector('[data-gallery-prev]');
        const next = gallery.querySelector('[data-gallery-next]');
        const counter = gallery.querySelector('[data-gallery-count]');
        const mobile = window.matchMedia('(max-width:749px)');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let active = 0;
        let trackWidth = track.clientWidth;
        const isCarousel = () => ['featured_thumbnails', 'carousel_peek'].includes(mobile.matches ? gallery.dataset.mobileLayout : gallery.dataset.desktopLayout);
        const update = () => {
          if (!isCarousel() || track.clientWidth !== trackWidth) return;
          const bounds = track.getBoundingClientRect();
          active = slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - bounds.left) < Math.abs(slides[best].getBoundingClientRect().left - bounds.left) ? index : best, 0);
          if (track.scrollLeft > 0 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) active = slides.length - 1;
          thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
          if (previous) previous.disabled = active === 0;
          if (next) next.disabled = active === slides.length - 1;
          if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
          const selected = thumbs[active];
          if (selected) {
            const strip = selected.parentElement;
            const item = selected.getBoundingClientRect();
            const view = strip.getBoundingClientRect();
            if (item.left < view.left || item.right > view.right) strip.scrollBy({left: item.left - view.left - (view.width - item.width) / 2, behavior: 'instant'});
          }
        };
        const move = index => {
          if (!isCarousel()) return;
          active = Math.max(0, Math.min(slides.length - 1, index));
          track.scrollTo({left: track.scrollLeft + slides[active].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduced.matches ? 'instant' : 'smooth'});
        };
        thumbs.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.imageIndex)), {signal}));
        previous?.addEventListener('click', () => move(active - 1), {signal});
        next?.addEventListener('click', () => move(active + 1), {signal});
        this.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-slide]'); if (slide && track.contains(slide)) move(Number(slide.dataset.slide)); }, {signal});
        track.addEventListener('scroll', update, {signal, passive: true});
        track.addEventListener('keydown', event => {
          if (event.target !== track || !isCarousel()) return;
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, {signal});
        this.galleryResize = new ResizeObserver(() => {
          trackWidth = track.clientWidth;
          if (isCarousel() && slides[active]) track.scrollTo({left: track.scrollLeft + slides[active].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'instant'});
          update();
        });
        this.galleryResize.observe(track);
        update();
      }
      const giftTrack = this.querySelector('[data-gift-track]');
      if (giftTrack) {
        const cards = [...giftTrack.querySelectorAll('.bsc-gift-option')];
        const previous = this.querySelector('[data-gift-prev]');
        const next = this.querySelector('[data-gift-next]');
        const nav = this.querySelector('[data-gift-nav]');
        const behavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        const update = () => {
          const max = giftTrack.scrollWidth - giftTrack.clientWidth;
          if (nav) nav.hidden = max < 2;
          if (previous) previous.disabled = giftTrack.scrollLeft < 2;
          if (next) next.disabled = max < 2 || giftTrack.scrollLeft >= max - 2;
        };
        const move = direction => {
          if (!cards.length) return;
          const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(giftTrack).gap);
          giftTrack.scrollTo({left: giftTrack.scrollLeft + direction * step, behavior: behavior()});
        };
        const reveal = card => {
          if (!card) return;
          const view = giftTrack.getBoundingClientRect();
          const box = card.getBoundingClientRect();
          let offset = 0;
          if (box.left < view.left + 4) offset = box.left - view.left - 4;
          else if (box.right > view.right - 4) offset = box.right - view.right + 4;
          if (offset) giftTrack.scrollTo({left: giftTrack.scrollLeft + offset, behavior: 'instant'});
        };
        previous?.addEventListener('click', () => move(-1), {signal});
        next?.addEventListener('click', () => move(1), {signal});
        giftTrack.addEventListener('scroll', update, {signal, passive:true});
        giftTrack.addEventListener('focusin', event => reveal(event.target.closest('.bsc-gift-option')), {signal});
        giftTrack.addEventListener('keydown', event => {
          if (event.target !== giftTrack) return;
          if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
            event.preventDefault();
            if (event.key === 'Home' || event.key === 'End') giftTrack.scrollTo({left:event.key === 'Home' ? 0 : giftTrack.scrollWidth, behavior:behavior()});
            else move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, {signal});
        this.addEventListener('shopify:block:select', event => reveal(event.target.closest('.bsc-gift-option')), {signal});
        this.giftResize = new ResizeObserver(update);
        this.giftResize.observe(giftTrack);
        update();
      }
      if (!this.form || !this.buy) return;
      this.querySelectorAll('[data-gift-choice]').forEach(input => input.addEventListener('change', () => {
        this.status.textContent = input.dataset.message;
        this.status.dataset.error = 'false';
        this.querySelector('[data-buy-text]').textContent = this.dataset.addLabel;
        if (this.sticky) {
          this.querySelector('[data-sticky-label]').textContent = this.dataset.addLabel;
          this.querySelector('[data-sticky-summary]').textContent = input.dataset.message;
        }
      }, { signal }));
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const chosen = this.form.querySelector('[data-gift-choice]:checked');
        const bundleId = this.form.querySelector('[data-bundle-id]')?.value;
        if (!chosen || chosen.disabled || !chosen.value || !bundleId || this.buy.disabled) return;
        this.busy = true;
        this.buy.disabled = true;
        this.buy.setAttribute('aria-busy', 'true');
        this.querySelector('[data-buy-text]').textContent = this.dataset.addingLabel;
        this.status.dataset.error = 'false';
        const properties = Object.fromEntries([...this.form.querySelectorAll('[data-bundle-property]')].map(field => [field.dataset.bundleProperty, field.value]));
        const items = [
          {id: bundleId, quantity: 1, properties},
          {id: chosen.value, quantity: 1, properties: {_bsc_bonus_for: bundleId}}
        ];
        const discount = (this.dataset.giftDiscount || '').trim();
        const drawer = document.querySelector('cart-drawer');
        const trigger = document.activeElement instanceof HTMLElement ? document.activeElement : this.buy;
        let cartAdded = false;
        try {
          if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') {
            throw new Error(this.dataset.drawerUnavailableLabel);
          }
          const sections = drawer.getSectionsToRender().map(section => section.id);
          drawer.setActiveElement(trigger);
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({items, sections, sections_url: window.location.pathname}),
            credentials: 'same-origin'
          });
          let payload = await response.json();
          if (!response.ok || payload.status) throw new Error(typeof payload.description === 'string' ? payload.description : this.dataset.errorLabel);
          cartAdded = true;
          if (discount) {
            const discountUrl = `${this.dataset.rootUrl || '/'}discount/${encodeURIComponent(discount)}?redirect=${encodeURIComponent(this.dataset.cartUrl)}`;
            const discountResponse = await fetch(discountUrl, {credentials: 'same-origin', cache: 'no-store'});
            if (!discountResponse.ok) throw new Error(this.dataset.cartReviewLabel);
          }
          const sectionsReady = state => drawer.getSectionsToRender().every(section => {
            const html = state.sections?.[section.id];
            if (typeof html !== 'string') return false;
            const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            return target && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
          });
          if (discount || !sectionsReady(payload)) {
            const refreshUrl = new URL(window.location.href);
            refreshUrl.searchParams.delete('section_id');
            refreshUrl.searchParams.set('sections', sections.join(','));
            const refreshResponse = await fetch(refreshUrl.toString(), {headers: {Accept: 'application/json'}, credentials: 'same-origin', cache: 'no-store'});
            if (!refreshResponse.ok) throw new Error(this.dataset.cartReviewLabel);
            payload.sections = await refreshResponse.json();
          }
          if (!sectionsReady(payload)) throw new Error(this.dataset.cartReviewLabel);
          drawer.classList.remove('is-empty');
          drawer.renderContents(payload);
          this.status.textContent = this.dataset.addedLabel;
          this.status.dataset.error = 'false';
        } catch (error) {
          this.status.textContent = cartAdded ? this.dataset.cartReviewLabel : (error.message || this.dataset.errorLabel);
          if (cartAdded) {
            const link = document.createElement('a');
            link.href = this.dataset.cartUrl;
            link.textContent = this.dataset.viewCartLabel;
            this.status.append(' ', link);
          }
          this.status.dataset.error = 'true';
          this.status.setAttribute('tabindex', '-1');
          this.status.focus();
        } finally {
          this.busy = false;
          this.buy.disabled = false;
          this.buy.removeAttribute('aria-busy');
          this.querySelector('[data-buy-text]').textContent = this.dataset.addLabel;
        }
      }, { signal });
      if (this.sticky) {
        this.querySelector('[data-sticky-buy]').addEventListener('click', () => {
          if (this.busy) return;
          const selected = this.form.querySelector('[data-gift-choice]:checked');
          if (selected) this.form.requestSubmit();
          else {
            const field = this.querySelector('.bsc-gifts');
            field.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
            field.querySelector('input:not(:disabled)')?.focus({ preventScroll: true });
          }
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => { this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > window.innerHeight; });
          this.observer.observe(this.buy);
        }
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.galleryResize?.disconnect(); this.giftResize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsc-review"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsc-review-carousel')) {
  customElements.define('bsc-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('[data-review-track]');
      const slides = [...this.querySelectorAll('[data-review-slide]')];
      const prev = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const counter = this.querySelector('[data-review-count]');
      if (!track || !slides.length) return;
      let active = 0;
      const update = () => {
        const left = track.getBoundingClientRect().left;
        active = slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best, 0);
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = active === slides.length - 1;
        if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      };
      const move = (index, instant = false) => {
        active = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left: track.scrollLeft + slides[active].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev?.addEventListener('click', () => move(active - 1), {signal});
      next?.addEventListener('click', () => move(active + 1), {signal});
      track.addEventListener('scroll', update, {signal, passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-review-slide]');
        const index = slides.indexOf(slide);
        if (index >= 0) move(index, true);
      }, {signal});
      this.resize = new ResizeObserver(() => {move(active, true); update();});
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() {this.abort?.abort(); this.resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsc-soap-carousel"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bsc-soap-carousel')) {customElements.define('bsc-soap-carousel', class extends HTMLElement {

connectedCallback(){this.abort=new AbortController();const signal=this.abort.signal;const track=this.querySelector('[data-track]');const prev=this.querySelector('[data-prev]');const next=this.querySelector('[data-next]');const progress=this.querySelector('[data-progress]');if(!track)return;const update=()=>{const max=track.scrollWidth-track.clientWidth;const fraction=max>0?track.scrollLeft/max:0;const width=track.scrollWidth>0?track.clientWidth/track.scrollWidth*100:100;prev.disabled=track.scrollLeft<3;next.disabled=max<3||track.scrollLeft>max-3;progress.style.width=width+'%';progress.style.transform='translateX('+(fraction*(100-width)/width*100)+'%)';};const move=direction=>{const card=track.firstElementChild;if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});track.addEventListener('scroll',update,{signal,passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}},{signal});window.addEventListener('resize',update,{signal,passive:true});this.resize=new ResizeObserver(update);this.resize.observe(track);update();}

disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}

});}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
